import React, { useState, useEffect } from "react";
import BusinessesforSaleCSS from "./filter.module.css";
import Footer from "../Footer/Footer";
import Nav from "../Nav/Nav";

import useStore from "../../../Store";
import BusinessCard from "./BusinessCard";
import BusinessesforSale1 from "./BusinessesforSale1";
import Filters from "./Filters";
import CreateBusinessModal from "./CreateBusinessModal";
import { useNavigate } from "react-router-dom";
import { businessForSalefilter } from "../../../Services/APIrequests";

import { SuccessSwal, warningSwal } from "../../../Util/Toast";
import { FaFilter } from "react-icons/fa6";
import ReactPaginate from "react-paginate";
import { RotatingLines } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
const BusinessesforSale = () => {
    const direction = useStore((state) => state.direction);
    const location = useLocation();
    const [isFilterOpen, setIsFilterOpen] = useState(true);
    const navigate = useNavigate();
    const [businessFilters, setBusinessFilters] = useState([]);
    const [businesses, setBusinesses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [newBusiness, setNewBusiness] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    // Function to update the businesses list after adding a new one
    const addNewBusiness = (business) => {
        if (page == 1) {
            fetchBusinessesForSale(1);
        } else {
            setPage(1);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewBusiness((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleFilterChange = (filterName, value) => {
        setBusinessFilters(filterName);
    };
    const fetchBusinessesForSale = async (currentPage) => {
        try {
            const requestBody = {};
            const response = await businessForSalefilter(
                requestBody,
                currentPage,
                limit
            );
            setBusinesses(response.data.data);
            setTotalCount(response.data.totalCount);
            setBusinessFilters(response.data.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching businesses:", error);
            setBusinesses([]);
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchBusinessesForSale(page);
    }, [page, limit]);

    const toggleFilter = () => {
        setIsFilterOpen(!isFilterOpen);
    };

    const handlePageClick = (data) => {
        setPage(data.selected + 1);
    };

    const isTokenPresent = sessionStorage.getItem("token");

    const handleCreateBusinessClick = () => {
        if (isTokenPresent) {
            setShowCreateForm(true);
        } else {
            navigate("/login", { state: { from: location.pathname } });
        }
    };

    return (
        <div style={{ direction }}>
            <Nav />
            <div className={BusinessesforSaleCSS.about_container}>
                <BusinessesforSale1 />
            </div>

            <div
                className={
                    BusinessesforSaleCSS.BusinessesforSale_container_cards
                }>
                <div
                    className={
                        BusinessesforSaleCSS.BusinessesforSale_filter_container
                    }>
                    <div
                        className={
                            BusinessesforSaleCSS.BusinessesforSale_filter_section
                        }>
                        <div
                            className={
                                BusinessesforSaleCSS.BusinessesforSale_filter_section_header
                            }
                            onClick={toggleFilter}>
                            <h3
                                className={
                                    BusinessesforSaleCSS.BusinessesforSale_filter_section_heading
                                }>
                                <div
                                    className={
                                        BusinessesforSaleCSS.Filter_icon
                                    }>
                                    <FaFilter />
                                </div>
                                <div>Filter By</div>
                            </h3>
                        </div>
                        <div
                            className={
                                BusinessesforSaleCSS.BusinessesforSale_filter
                            }>
                            {isFilterOpen && (
                                <Filters
                                    activeTab="businesses"
                                    businessFilters={businessFilters}
                                    onFilterChange={handleFilterChange}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className={BusinessesforSaleCSS.BusinessesforSalecontainer}>
                    <div
                        className={
                            BusinessesforSaleCSS.BusinessesforSalecontainerHeading
                        }>
                        <h2>Businesses for Sale</h2>
                        <p>
                            Explore businesses for sale and investment
                            opportunities. Buy or invest in a business.
                        </p>
                        <button onClick={handleCreateBusinessClick}>
                            Create Business for Sale
                        </button>
                    </div>

                    {/* Show the CreateBusinessModal if the form is visible */}
                    {showCreateForm && (
                        <CreateBusinessModal
                            showCreateForm={showCreateForm}
                            setShowCreateForm={setShowCreateForm}
                            className={`${BusinessesforSaleCSS.modalContent} ${
                                newBusiness.theme !== "default" ? "green" : ""
                            }`}
                            newBusiness={newBusiness}
                            handleInputChange={handleInputChange}
                            addNewBusiness={addNewBusiness}
                        />
                    )}

                    <div>
                        {loading ? (
                            <p>
                                {" "}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100vh",
                                    }}>
                                    <RotatingLines
                                        height="80"
                                        width="80"
                                        color="#4fa94d"
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    />
                                </div>
                            </p>
                        ) : businessFilters.length === 0 ? (
                            <p style={{ fontSize: "18px", color: "#555" }}>
                                No businesses available
                            </p>
                        ) : (
                            <div
                                className={
                                    BusinessesforSaleCSS.BusinessesforSalecardssection
                                }>
                                {businessFilters.map((card, index) => (
                                    <BusinessCard
                                        key={index}
                                        CIN={card.CIN}
                                        title={card.business_name}
                                        location={card.location}
                                        about_company={card.about_company}
                                        pat={card.pat}
                                        turn_over={card.turn_over}
                                        isContact={card.isContact}
                                        paid_up_capital={card.paid_up_capital}
                                        authorised_capital={
                                            card.authorised_capital
                                        }
                                        sale_price={card.sale_price}
                                        business_image={card.business_image}
                                        date_of_incorporation={
                                            card.date_of_incorporation
                                        }
                                        legal_entity={card.legal_entity}
                                        industry={
                                            Array.isArray(card.industry)
                                                ? card.industry[0]
                                                : card.industry
                                        }
                                    />
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Pagination using React Paginate */}
                    <div>
                        <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            pageCount={Math.ceil(totalCount / limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            disabledClassName={"disabled"}
                        />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default BusinessesforSale;
